<template>
	<div class="col-sm-3">
		<div class="box">
			<div class="box-header with-border">
				<h3 class="box-title">
					<i class="fa fa-cogs"></i>
					Configurações
				</h3>
			</div>
			<div class="box-body">
				<div class="row">
					<div class="col-sm-12">
						<span>Titulo do formulário</span>
						<input
							v-model="form.chForm.settings.title"
							type="text"
							class="form-control"
						/>
					</div>
				</div>
				<span>Tamanho do modal</span>
				<div class="well well-sm" style="margin-bottom: 10px">
					<div class="row">
						<div class="col-sm-12 radio margin-none">
							<label>
								<input
									v-model="form.chForm.settings.width"
									value="modal-lg"
									type="radio"
								/>
								<span>Grande</span>
							</label>
						</div>

						<div class="col-sm-12 radio margin-none">
							<label>
								<input
									v-model="form.chForm.settings.width"
									value="modal-md"
									type="radio"
								/>
								<span>Médio</span>
							</label>
						</div>

						<div class="col-sm-12 radio margin-none">
							<label>
								<input
									v-model="form.chForm.settings.width"
									value="modal-sm"
									type="radio"
								/>
								<span>Pequeno</span>
							</label>
						</div>
					</div>
				</div>
				<span>Botões</span>
				<div class="well well-sm" style="margin-bottom: 10px">
					<div class="row">
						<div class="col-sm-12 checkbox margin-none">
							<label>
								<input
									v-model="form.chForm.settings.cancelButton"
									type="checkbox"
								/>
								<span>Botão de cancelar</span>
							</label>
						</div>

						<div class="col-sm-12 checkbox margin-none">
							<label>
								<input
									v-model="form.chForm.settings.saveButton"
									type="checkbox"
								/>
								<span>Botão de Salvar</span>
							</label>
						</div>

						<div class="col-sm-12 checkbox margin-none">
							<label>
								<input
									v-model="form.chForm.settings.mailButton"
									type="checkbox"
								/>
								<span>Enviar email</span>
							</label>
						</div>

						<div class="col-sm-12 checkbox margin-none">
							<label>
								<input
									v-model="form.chForm.settings.printButton"
									type="checkbox"
								/>
								<span>Botão de imprimir</span>
							</label>
						</div>
					</div>
				</div>
				<label>
					<input
						v-model="form.chForm.settings.required"
						type="checkbox"
					/>
					<span>Obrigatório</span>
				</label>
			</div>
			<div class="box-footer">
				<div class="row">
					<div class="col-sm-12">
						<button
							class="btn btn-danger btn-block"
							@click="form.resetForm"
						>
							<i class="fa fa-trash"></i>
							Resetar formulário
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		computed: {
			form() {
				return this.$parent;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/create-form/components/settings.vue